import * as React from "react";
import moment from "moment";
import upperFirst from "lodash/upperFirst";
import { Trans, useTranslation } from "react-i18next";
import { fromFormStateValue as hourFromFormValue } from "report/common/MinuteOfHourInput";
import { FREQUENCY_OPTIONS } from "report/report-configuration-page/SchedulingFrequencyForm";
import toUTCFrequencyTime from "report/report-configuration-page/toUTCFrequencyTime";
const TimeInfo = ({ time, timezone }) => {
  const { t } = useTranslation("enterprise_report");
  if (!time) {
    return /* @__PURE__ */ React.createElement("i", null, t("frequency_summary.time_not_configured"));
  }
  const utcHourAndMinute = toUTCFrequencyTime(time, timezone);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, t("frequency_summary.time_info", { time, timezone: timezone != null ? timezone : "UTC", utcTime: utcHourAndMinute }));
};
const FrequencySummary = ({ frequency, frequencyConfiguration }) => {
  const { t } = useTranslation("enterprise_report");
  const placeholder = /* @__PURE__ */ React.createElement(React.Fragment, null, t("frequency_summary.no_options_selected"));
  if (!frequency || !frequencyConfiguration) {
    return placeholder;
  }
  switch (frequency) {
    case FREQUENCY_OPTIONS.HOURLY.value:
      if (frequencyConfiguration.time) {
        return /* @__PURE__ */ React.createElement(React.Fragment, null, t("frequency_summary.hourly", { minute: hourFromFormValue(frequencyConfiguration.time) }));
      }
      break;
    case FREQUENCY_OPTIONS.DAILY.value:
      if (frequencyConfiguration.time) {
        return /* @__PURE__ */ React.createElement(
          Trans,
          {
            t,
            i18nKey: "frequency_summary.daily",
            components: {
              timeInfo: /* @__PURE__ */ React.createElement(TimeInfo, { time: frequencyConfiguration.time, timezone: frequencyConfiguration.timezone })
            }
          }
        );
      }
      break;
    case FREQUENCY_OPTIONS.WEEKLY.value:
      if ("day_of_week" in frequencyConfiguration && frequencyConfiguration.day_of_week && frequencyConfiguration.time) {
        const dayOfWeek = frequencyConfiguration.day_of_week;
        return /* @__PURE__ */ React.createElement(
          Trans,
          {
            t,
            i18nKey: "frequency_summary.weekly",
            values: {
              day: t(`day_of_week.days.${dayOfWeek}`, { defaultValue: upperFirst(dayOfWeek) })
            },
            components: {
              timeInfo: /* @__PURE__ */ React.createElement(TimeInfo, { time: frequencyConfiguration.time, timezone: frequencyConfiguration.timezone })
            }
          }
        );
      }
      break;
    case FREQUENCY_OPTIONS.MONTHLY.value:
      if ("day_of_month" in frequencyConfiguration && frequencyConfiguration.day_of_month && frequencyConfiguration.time) {
        const ordinalDay = moment.localeData().ordinal(upperFirst(frequencyConfiguration.day_of_month));
        return /* @__PURE__ */ React.createElement(
          Trans,
          {
            t,
            i18nKey: "frequency_summary.monthly",
            values: { day: ordinalDay },
            components: {
              timeInfo: /* @__PURE__ */ React.createElement(TimeInfo, { time: frequencyConfiguration.time, timezone: frequencyConfiguration.timezone })
            }
          }
        );
      }
      break;
    default:
      break;
  }
  return placeholder;
};
export default FrequencySummary;
